/*
 *
 * GroupingList reducer
 *
 */

import { fromJS } from 'immutable';
import { makeImmutable } from 'utils/immutableUtils';
import {
  RECEIVE_CREDENTIAL_TYPES,
} from './constants';

const initialState = fromJS({ credentialTypeList: [] });

function credentialTypeListReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_CREDENTIAL_TYPES:
      return state.set('credentialTypeList', makeImmutable(action.credentialTypes));
    default:
      return state;
  }
}

export default credentialTypeListReducer;
